import Request from "./constants/Request.api"
import Response from "./constants/Response.api"
import Api from "./Api"

class Authentication extends Api {
  registerUser = user => {
    const request = new Request({
      data: {
        first_name: user.firstName,
        last_name: user.lastName,
        other_name: user.otherNames,
        telephone: user.phone,
        email: user.email,
        url: "clients",
      },
    })

    const response = this.postRequest(request)
    return response
  }

  validateOTP = user => {
    const request = new Request({
      data: {
        username: user.email,
        otp: user.otp,
        url: "client/confirm-otp",
      },
    })

    const response = this.postRequest(request)
    return response
  }

  createPassword = user => {
    const request = new Request({
      data: {
        username: user.email,
        password: user.password,
        url: "client/password",
      },
    })

    const response = this.postRequest(request)
    return response
  }

  login = user => {
    const request = new Request({
      data: {
        username: user.username,
        password: user.password,
        url: "clients/login",
      },
    })

    const response = this.postRequest(request)
    return response
  }

  resetPassword = user => {
    const request = new Request({
      data: {
        username: user.username,
        password: user.password,
        url: "clients/reset-password",
      },
    })

    const response = this.postRequest(request)
    return response
  }

  updateUser = user => {
    const request = new Request({
      data: {
        ...user,
        url: "client/" + user.id,
        token: "Bearer " + user.token,
      },
    })

    const response = this.putRequest(request)
    return response
  }
}

export default Authentication
